import auth from '@api/auth'
import session from '@api/session'
import {
  LOGIN_BEGIN,
  LOGIN_FAILURE,
  LOGIN_SUCCESS,
  LOGOUT,
  SET_TOKEN,
} from './_types'
import getErrorMessage from '@utils/getErrorMessage'

const getDefaultState = () => {
  return {
    // currentUser: getSavedState('auth.currentUser'),
    authenticationLoading: false,
    error: false,
    socialAuthErrorMessage: '',
    token: getSavedState('auth.token'),
  }
}
export const state = getDefaultState()

export const getters = {
  // Whether the user is currently logged in.
  loggedIn: (state) => !!state.token,
}

export const mutations = {
  [SET_TOKEN](state, newValue) {
    state.token = newValue
    saveState('auth.token', newValue)
    setDefaultAuthHeaders(state)
  },
  [LOGIN_BEGIN](state) {
    state.authenticationLoading = true
    state.error = false
    state.socialAuthErrorMessage = ''
  },
  [LOGIN_FAILURE](state, error) {
    state.authenticationLoading = false
    state.error = true
    state.socialAuthErrorMessage = error
  },
  [LOGIN_SUCCESS](state) {
    state.authenticationLoading = false
    state.error = false
  },
  [LOGOUT](state) {
    state.authenticationLoading = false
    state.error = false
  },
}

export const actions = {
  // This is automatically run in `src/state/store.js` when the app
  // starts, along with any other actions named `init` in other modules.
  init({ state }) {
    setDefaultAuthHeaders(state)
  },

  // Logs in the current user.
  logIn({ commit, dispatch, getters }, { username, password } = {}) {
    if (getters.loggedIn) return dispatch('validate')
    commit(LOGIN_BEGIN)

    return auth.login(username, password).then((response) => {
      const token = response.data.key
      commit('SET_TOKEN', token)
      return token
    }).then(() => {
      commit(LOGIN_SUCCESS)
    }).catch(() => commit(LOGIN_FAILURE))
  },

  loginWith({ commit, dispatch, getters }, options) {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone

    if (options.provider === 'google') {
      commit(LOGIN_BEGIN)
      const data = {
        ...options,
        timezone,
      }
      return auth.loginWithGoogle(data).then((response) => {
        const token = response.data.key
        commit('SET_TOKEN', token)
        return token
      }).then(() => {
        commit(LOGIN_SUCCESS)
      }).catch((error) => {
        const errorMessage = getErrorMessage(error)
        commit(LOGIN_FAILURE, errorMessage)
      })
    }
  },

  // Logs out the current user.
  logOut({ commit }) {
    return auth.logout().then(() => {
      commit('SET_TOKEN', null)
    }).then(() => {
      commit(LOGOUT)
    })
  },

  // Validates the current user's token and refreshes it
  // with new data from the API.
  validate({ commit, dispatch, state }) {
    if (!state.token) return Promise.resolve(null)

    return dispatch('users/getAccountDetails', {}, { root: true })
      .then((validUser) => {
        if (!validUser) {
          commit('SET_TOKEN', null)
        }

        return Promise.resolve(validUser)
      }).catch(() => {
        commit('SET_TOKEN', null)

        return Promise.resolve(null)
      })
  },

  resendConfirmationEmail() {
    return auth.resendConfirmationEmail()
  },
}

// ===
// Private helpers
// ===

function getSavedState(key) {
  const retrieverKey = window.localStorage.getItem(key)
  if (retrieverKey === 'undefined') {
    return ''
  } else {
    return JSON.parse(window.localStorage.getItem(key))
  }
}

function saveState(key, state) {
  // Don't even think about removing the JSON.stringify
  window.localStorage.setItem(key, JSON.stringify(state))
}

function setDefaultAuthHeaders(state) {
  session.defaults.headers.Authorization = state.token
    ? `Token ${state.token}`
    : ''
}
